import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { FachbereicheProvider } from './contexts/FachbereicheContext';
import { BackendStatusProvider } from './contexts/BackendStatusContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BackendStatusProvider>
      <AuthProvider>
        <FachbereicheProvider>
          <App />
        </FachbereicheProvider>
      </AuthProvider>
    </BackendStatusProvider>
  </React.StrictMode>
);

